module.exports = __webpack_public_path__ + "assets/8536f9b709151374dd965e96fe6b5254.webm";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/images-desktop/celebrations/fireworks.webm
 ** module id = 65
 ** module chunks = 0
 **/